module.exports = __webpack_public_path__ + "static/media/upload_more.bc971c53.svg";